import type { FlagsVariant } from 'mixpanel-browser';
import { match } from 'ts-pattern';
import { devtools } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export type MixpanelFlagsStatus = 'idle' | 'loading' | 'cache' | 'ready' | 'failed';

type MixpanelFlagsValues = {
  status: MixpanelFlagsStatus;
  variants: Record<string, FlagsVariant>;
};

type MixpanelFlagsActions = {
  publish: (status: MixpanelFlagsStatus, variants: Record<string, FlagsVariant>) => void;
  reset: () => void;
};

const initialState: MixpanelFlagsValues = {
  status: 'idle',
  variants: {},
};

export const isSettledStatus = (status: MixpanelFlagsStatus): boolean =>
  match(status)
    .with('cache', 'ready', 'failed', () => true)
    .with('idle', 'loading', () => false)
    .exhaustive();

export const useMixpanelFlagsStore = createWithEqualityFn<
  MixpanelFlagsValues & MixpanelFlagsActions
>()(
  devtools(
    (set) => ({
      ...initialState,
      publish: (status, variants) => set({ status, variants }, false, 'publish'),
      reset: () => set(initialState, false, 'reset'),
    }),
    { name: 'MixpanelFlagsStore' }
  ),
  shallow
);
